import React from 'react';
import '../less/index.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import additionalCards from '../enums/additional_cards_data.json';
import hero_data from '../enums/hero_data.json';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import howToBlockItemsData from '../enums/how_to_block_items.json';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import aboutServiceData from '../enums/about_service_data.json';
import serviceTermsData from '../enums/service_terms_items.json';
import DOMPurify from 'utils/sanitize';

const imagesMap = {
  how_to_block_img_1,
  how_to_block_img_2,
  how_to_block_img_3
};

export default function template() {
  const page = 'money-auto-new';

  const howToBlockItems = howToBlockItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="money-auto-new">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <div className="about-service">
          <div className="container">
            <h2 className="about-service__title">{this.l10n('MONEY_AUTO_NEW_ABOUT_SERVICE_TITLE')}</h2>
            <p className="about-service__subtitle">{this.l10n('MONEY_AUTO_NEW_ABOUT_SERVICE_SUBTITLE')}</p>
            <div className="about-service__body">
              {aboutServiceData.map((item, index) => (
                <div key={index} className="about-service__item item-about-service">
                  <div className="item-about-service__title">{this.l10n(item.title)}</div>
                  <div className="item-about-service__text">{this.l10n(item.text)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="service-terms">
          <div className="container">
            <h2 className="service-terms__title">{this.l10n('MONEY_AUTO_NEW_SERVICE_TERMS_TITLE')}</h2>
            <div className="service-terms__body">
              {serviceTermsData.map((item, index) => (
                <div key={index} className="service-terms__item item-service-terms">
                  <div className="item-service-terms__title">{this.l10n(item.title)}</div>
                  <div className="item-service-terms__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(item.text))}}></div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <HowToBlockNew
          title={'MONEY_AUTO_NEW_HOW_TO_TITLE'}
          items={howToBlockItems}
        />
        <AdditionalProduct
          items={additionalCards}
          title={'MONEY_AUTO_NEW_ADDITIONAL_PRODUCT_TITLE'}
          page={page}
        />
        <QuestionsAdminNew
          loader={this.state.loader}
          page={page}
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'MONEY_AUTO_NEW_QUESTIONS_TITLE'}
        />
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
        />
        <TextAboveFooterNew
          widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('MONEY_AUTO_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('MONEY_AUTO_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
    </div>
  );
}
